import React, { useEffect, useState } from 'react';
import SheetSkeleton from '../sheet/sheetSkeleton';


import { Modal, notification } from 'antd';
import OtpInput from '../input/otpInput';
import CheckUserHasPin from '../../functions/user/checkUserHasPin';
import AddUserPin from '../../functions/user/addUserPin';
import { useUser } from '../../screens/user/context.js/userContext';

const AskNewPin = ({ open, close, userId, created }) => {
    const [pin, setPin] = useState('')
    const [confirmPin, setConfirmPin] = useState('')
    const { setPaying } = useUser()
    const [wrongAttempt, setWrongAttempt] = useState(false)
    const changePin = async (e) => {
        setPin(e)
    }
    const changeConfirmPin = async (e) => {
        setConfirmPin(e)
        if (e && e.length === 4 && pin && pin.length === 4 && pin === e) {
            pinSet()
        }
        else
            if (e.length === 4 && pin && pin.length === 4 && pin !== e) {
                shake()
            }
    }
    const pinSet = async () => {
        setPaying('ПИН код үүсгэж байна...')
        const result = await AddUserPin(userId, pin)
        setPaying(null)
        if (result && result.success) {
            created()
            notification.success({ message: 'ПИН код амжилттай үүсгэгдлээ' })
            return;
        }
    }
    const shake = () => {
        setWrongAttempt(true)
        setTimeout(() => {
            setWrongAttempt(false)
        }, 500);
    }

    return (
        <Modal open={open} size={250} title='Шинэ ПИН үүсгэх' footer={null} close={close}>
            <div style={{ padding: 10 }}>
                <p style={{ textAlign: 'center', fontSize: 14, color: '#555', marginBottom: 15 }}>
                    Та гүйлгээний аюулгүй байдлыг хангахын тулд 4 оронтой ПИН код оруулна уу.
                </p>
                <OtpInput
                    value={pin}
                    onChange={changePin}
                    style={{ marginBottom: 20 }}
                />

                <h3 style={{ textAlign: 'center', marginBottom: 15 }}>Давтан оруулна уу</h3>
                <OtpInput
                    value={confirmPin}
                    wrong={wrongAttempt}
                    onChange={changeConfirmPin}
                />
            </div>
        </Modal>

    );
};

export default AskNewPin;